import { useContext } from 'react';

import { BuildingWrapperContext } from 'src/modules/designStudio/providers';
import type {
  BuildingAppearances,
  MutateBuildingFunction,
} from 'src/modules/designStudio/providers/MacheteBuildingProvider/types';

export const useBuildingDesigner = (): {
  buildingAppearances: BuildingAppearances;
  mutateBuilding: (update: MutateBuildingFunction) => void;
} => {
  const { buildingAppearances, mutateBuilding } = useContext(
    BuildingWrapperContext,
  );

  return {
    buildingAppearances,
    mutateBuilding,
  };
};
